<template>

    <section class="smart-match">
    
    
      <div class="smart-header">
    
        <div class="smart-icon">
    
          ✨
    
        </div>
    
    
        <div>
    
          <span>
            AI Smart Match
          </span>
    
    
          <h4>
            Оценка соответствия
          </h4>
    
        </div>
    
    
      </div>
    
    
    
      <div class="overall-block">
    
        <div class="overall-value">
    
          <strong>
            {{ overall }}%
          </strong>
    
    
          <span>
            Общее совпадение
          </span>
    
    
        </div>
    
    
      </div>
    
    
    
    
      <div class="scores">
    
        <ScoreCircle
          title="Опыт"
          :value="experience"
        />
    
    
        <ScoreCircle
          title="Навыки"
          :value="skills"
        />
    
    
      </div>
    
    
    
    
      <div
        v-if="strengths.length"
        class="match-section"
      >
    
        <h5>
          Сильные стороны
        </h5>
    
    
        <ul>
    
          <li
            v-for="item in strengths"
            :key="item"
          >
    
            <span class="good">
              ✓
            </span>
    
            {{ item }}
    
          </li>
    
        </ul>
    
    
      </div>
    
    
    
    
      <div
        v-if="risks.length"
        class="match-section risks"
      >
    
        <h5>
          Риски
        </h5>
    
    
        <ul>
    
          <li
            v-for="item in risks"
            :key="item"
          >
    
            <span class="bad">
              !
            </span>
    
    
            {{ item }}
    
          </li>
    
    
        </ul>
    
    
      </div>
    
    
    
    </section>
    
    </template>
    
    
    
    <script setup>
    
    import ScoreCircle
    from "./ScoreCircle.vue";
    
    
    const props = defineProps({
    
      smartMatch:{
        type:Object,
        default:()=>({})
      }
    
    });
    
    
    const scores =
    props.smartMatch?.scores || {};
    
    
    const overall =
    scores.overall ?? 0;
    
    
    const experience =
    scores.experience ?? 0;
    
    
    const skills =
    scores.skills ?? 0;
    
    
    const strengths =
    props.smartMatch?.strengths || [];
    
    
    const risks =
    props.smartMatch?.risks || [];
    
    
    </script>
    
    
    
    <style scoped>
    
    
    .smart-match {
    
      display:flex;
    
      flex-direction:column;
      flex-shrink: 0;
      gap:16px;
    
    
      padding:17px;
    
    
      background:
    
        linear-gradient(
          145deg,
          rgba(53,132,247,.08),
          rgba(105,82,228,.04)
        ),
    
        var(--drawer-surface);
    
    
      border:
    
        1px solid
        rgba(53,132,247,.15);
    
    
      border-radius:18px;
    
    
    }
    
    
    
    /* HEADER */
    
    .smart-header {
    
      display:flex;
    
      align-items:center;
    
      gap:10px;
    
    }
    
    
    .smart-icon {
    
      width:36px;
      height:36px;
    
    
      display:flex;
    
      align-items:center;
      justify-content:center;
    
    
      color:white;
    
    
      background:
    
        linear-gradient(
          145deg,
          #3899f7,
          #6161df
        );
    
    
      border-radius:11px;
    
    
      font-size:18px;
    
    
    }
    
    
    
    .smart-header span {
    
      display:block;
    
    
      color:
        var(--drawer-text-muted);
    
    
      font-family:
        "Eastman-Regular";
    
    
      font-size:9px;
    
    }
    
    
    .smart-header h4 {
    
    
      margin:2px 0 0;
    
    
      color:
        var(--drawer-text);
    
    
      font-family:
        "Eastman-Bold";
    
    
      font-size:12px;
    
    
    }
    
    
    
    
    
    /* OVERALL */
    
    
    .overall-block {
    
    
      display:flex;
    
      justify-content:center;
    
    
      padding:8px 0;
    
    
    }
    
    
    .overall-value {
    
    
      width:120px;
      height:120px;
    
    
      display:flex;
    
      flex-direction:column;
    
      align-items:center;
    
      justify-content:center;
    
    
      background:
    
        radial-gradient(
          circle,
          rgba(61,130,237,.15),
          transparent 70%
        );
    
    
      border-radius:50%;
    
    
    }
    
    
    
    .overall-value strong {
    
    
      color:
        var(--drawer-text);
    
    
      font-family:
        "Eastman-Bold";
    
    
      font-size:32px;
    
    
    }
    
    
    
    .overall-value span {
    
    
      margin-top:4px;
    
    
      color:
        var(--drawer-text-secondary);
    
    
      font-family:
        "Eastman-Regular";
    
    
      font-size:10px;
    
    
    }
    
    
    
    
    /* SCORES */
    
    
    .scores {
    
    
      display:flex;
    
      justify-content:center;
    
      gap:28px;
    
    
      padding:5px 0 10px;
    
    
    }
    
    
    
    /* SECTIONS */
    
    
    .match-section {
    
    
      padding-top:12px;
    
    
      border-top:
    
        1px solid
        var(--drawer-border);
    
    
    }
    
    
    
    .match-section h5 {
    
    
      margin:0 0 10px;
    
    
      color:
        var(--drawer-text);
    
    
      font-family:
        "Eastman-Bold";
    
    
      font-size:11px;
    
    
    }
    
    
    
    
    .match-section ul {
    
    
      display:flex;
    
      flex-direction:column;
    
      gap:8px;
    
    
      margin:0;
    
      padding:0;
    
      list-style:none;
    
    
    }
    
    
    
    
    .match-section li {
    
    
      display:flex;
    
      align-items:flex-start;
    
      gap:8px;
    
    
      color:
        var(--drawer-text-secondary);
    
    
      font-family:
        "Eastman-Regular";
    
    
      font-size:11px;
    
    
      line-height:1.45;
    
    
    }
    
    
    
    .good,
    .bad {
    
    
      width:18px;
    
      height:18px;
    
    
      display:flex;
    
      align-items:center;
    
      justify-content:center;
    
    
      flex-shrink:0;
    
    
      border-radius:50%;
    
    
      font-family:
        "Eastman-Bold";
    
    
      font-size:10px;
    
    
    }
    
    
    
    .good {
    
      color:#32b56f;
    
      background:
        rgba(50,181,111,.12);
    
    }
    
    
    
    .bad {
    
      color:#d95359;
    
      background:
        rgba(216,79,85,.12);
    
    }
    
    
    
    /* DARK */
    
    
    [data-theme="dark"] .smart-match {
    
    
      background:
    
        linear-gradient(
          145deg,
          rgba(53,132,247,.12),
          rgba(105,82,228,.06)
        );
    
    }
    
    
    
    @media(max-width:700px){
    
      .scores {
    
        gap:18px;
    
      }
    
    
      .smart-match {
    
        padding:14px;
    
      }
    
    }
    
    
    </style>